import React from 'react';
import { useDispatch } from 'react-redux';
import { addItemToCart } from '../redux/actions/cartActions';
import { useNavigate } from 'react-router-dom';

const ProductList = ({ products, limit=4 }) => {
  const dispatch = useDispatch();

  const handleAddToCart = (product) => {
    dispatch(addItemToCart({ product, quantity: 1 }));
  };

  const navigate = useNavigate()

  return (
    <div className='flex flex-col md:flex-row flex-wrap gap-[20px] w-full items-start justify-start'>
      {products.map((product, index) => (
        <div className='w-full md:w-[30%] lg:w-[calc(25%-15px)] cursor-pointer'>
          {index < limit && <div key={product.id} onClick={() => {
            navigate(`/shop/${product.id}`)
          }} className='w-full md:max-w-[320px] min-width-[250px] flex flex-1 flex-col bg-white p-4 border-2 border-gray-200'>
            <img src={product.image} className='w-full h-[250px] object-cover' alt="" />
            <div className='flex flex-row items-center justify-center mt-5 bg-white'>
              <h3 className='text-md font-medium'>{product.name.length > 20 ? product.name.substring(0, 20) + "..." : product.name}</h3>
              <p className='bg-emerald-200 ml-auto p-2 px-3 rounded-full text-sm'> ₹ {product.price} /kg</p>
            </div>
            {/* <button
              className='bg-primary hover:bg-green-600 text-white transition-[0.5s] font-bold py-2 px-4 rounded'
              onClick={() => handleAddToCart(product)}
            >
              Add to Cart
            </button> */}
          </div>}
        </div>
      ))}
    </div>
  );
};

export default ProductList;